export const appId = 'FIQRKGPAUP';
export const apiKey = 'aa4511be66e31aef4b72e8edc3f9e071';

export let options: any = {
	autoselect:     true,
	autoWidth:      false,
	cssClasses: {
		noPrefix:     true,
		root:         'gs-FormSearch-autocomplete',
		hint:         'gs-FormSearch-input--hint',
		dropdownMenu: 'gs-FormSearch-resultsDropdown',
		suggestions:  'gs-FormSearch-resultsGroup',
		suggestion:   'gs-FormSearch-result',
		cursor:       'is-selected'
	}
};

export const source = {
	hitsPerPage: 6
};